import {MarkdownAtom, MarkdownAtomType} from "../../model/markdown/MarkdownText"

class PlainTextService {
    getAtomsAsPlainText(atoms: Array<MarkdownAtom>): string {
        let result = ""
        const settings = {
            previous: ''
        }
        atoms.forEach(atom => {
            switch (atom.type) {
                case MarkdownAtomType.PLAIN:
                    if (settings.previous === MarkdownAtomType.PLAIN) {
                        result += '\n'
                    }
                    result += atom.content
                    break
                case MarkdownAtomType.BOLD:
                case MarkdownAtomType.BOLD_ITALIC:
                case MarkdownAtomType.ITALIC:
                    result += atom.content
                    break
                case MarkdownAtomType.CHECKBOX:
                    if (atom.checked) {
                        result += '[x] ' + atom.content
                    } else {
                        result += '[ ] ' + atom.content
                    }
                    break
                case MarkdownAtomType.LINK:
                    result += atom.content + (atom.url ? ' (' + atom.url + ')' : '')
                    break
            }
            settings.previous = atom.type
        })
        return result
    }

    getCodeBlockAsPlainText(atoms: Array<MarkdownAtom>): string {
        let result = ''
        atoms.forEach(atom => {
            if (result.length > 0){
                result += '\n'
            }
            atom.subAtoms.forEach(atom => {
                result += atom.content
            })
        })
        return result
    }

    getOrderedListAsText(subParts: Array<MarkdownAtom>, startFrom: number): string {
        let result = ''
        let index = startFrom
        for (let i = 0; i < subParts.length; i++) {
            const subPart = subParts[i]
            if (i > 0) {
                result += '\n'
            }
            result += index.toString() + '. '
            for (let j = 0; j < subPart.indent; j++) {
                result += ' '
            }
            result += this.getAtomsAsPlainText(subPart.subAtoms)
            index++
        }
        return result
    }

    getTableAsPlainText(atoms: Array<MarkdownAtom>): string {
        let result = ''
        for (const rowAtom of atoms) {
            if (rowAtom.content === 'separator') continue

            if (result.length > 0) {
                result += '\n'
            }

            const cellTexts: string[] = []
            for (const cellAtom of rowAtom.subAtoms) {
                const cellContent = this.getAtomsAsPlainText(cellAtom.subAtoms)
                cellTexts.push(cellContent)
            }
            result += '| ' + cellTexts.join(' | ') + ' |'
        }
        return result
    }

    getUnorderedListAsText(subParts: Array<MarkdownAtom>): string {
        let result = ''
        for (let i = 0; i < subParts.length; i++) {
            const subPart = subParts[i]
            if (i > 0) {
                result += '\n'
            }
            result += '* '
            for (let j = 0; j < subPart.indent; j++) {
                result += ' '
            }
            result += this.getAtomsAsPlainText(subPart.subAtoms)
        }
        return result
    }
}

export const plainTextService = new PlainTextService()
